import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface ExpandedContentProps {
    children: ReactNode
    className?: string
    'data-testid'?: string
}

export function ExpandedContent({children, className, 'data-testid': testId}: ExpandedContentProps) {
    return (
        <div
            className={cn('pl-1 pt-2', className)}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
